<template>
  <header>
    <div v-if="skaVisaMiljo" class="environment">
      Miljö:
      <select v-model="valdMiljo" @change="bytMiljo">
        <option v-for="(miljo, index) in testMiljoer" :key="index">{{ miljo }}</option>
      </select>
    </div>
    <div class="page">
      <div
        :class="{ 'headerclass-inner-wide': currentRoute.path === '/sok' || currentRoute.path.startsWith('/foretag') || currentRoute.path === 'storlekskategori', 'headerclass-inner': currentRoute.path === '/' }">
        <div class="rubriklogga">
          <a href="https://www.bolagsverket.se/" target="_blank" rel="noopener" aria-label="Bolagsverket, öppnas i nytt fönster">
            <img src="../../../public/images/logo-bolagsverket.svg" alt="Logotyp, Bolagsverket" />
          </a>
        </div>
        <div class="rubrik">
          {{ $t("main.title") }}
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">

import { computed, ref, watch } from "vue";
import { RouteLocationNormalizedLoaded, useRouter } from "vue-router";

const props = defineProps<{
  miljo?: string
}>();

const router = useRouter();
const testMiljoer = ["dev", "proj9", "system", "accept"];
const currentRoute = ref<RouteLocationNormalizedLoaded>(router.currentRoute.value);
const valdMiljo = ref(props.miljo);
const skaVisaMiljo = computed(() => props.miljo !== null && props.miljo !== "" && props.miljo !== "prod");

const bytMiljo = () => {
if (valdMiljo.value === "dev") {
    window.location.href = "http://localhost:8080/";
  } else {
    window.location.href = 
      "https://sta-kvar-" + valdMiljo.value + ".bolagsverket.se";
  }
};

watch(
  () => props.miljo,
  (current) => {
    valdMiljo.value = current;
  }
);

watch(
  () => router.currentRoute.value,
  (to) => {
    currentRoute.value = to;
  }
);
</script>

<style lang="scss" scoped>
header img {
  width: auto;
  height: 2em;
  vertical-align: top;
}

.rubriklogga img {
  width: auto;
  height: 2em;
}

.environment {
  color: black;
  font-size: 14px;
  position: fixed;
  top: 0;
  left: 0;
  padding-left: 2em;
  padding-right: 2em;
  text-align: left;
  background: rgba(255, 100, 135, 0.2);
}

.environment select {
  border: 0;
  background: rgb(255 224 231);
}

.sprakvalknapp {
  display: inline;
  border: none;
  text-decoration: underline;
  background: none;
  float: right;
}

.rubrik {
  padding-top: 0.3em
}

.rubrik>span {
  font-size: 1.2em;
  color: #002857;
  font-weight: 700;
}

.headerclass .rubrik {
  display: inline-block;
}

.headerclass {
  margin-left: auto;
}

.headerclass-inner {
  max-width: 75em;
  margin: 0 auto;
  width: 100%;
  height: 100%;
}

.headerclass-inner-wide {
  max-width: 75em;
  margin: 0 auto;
  width: 100%;
  height: 100%;
}

header {
  background: #ffffff;
  padding: 1em;
}

/* small screen styling */
@media screen and (max-width: 35em) {
  p {
    margin: 0;
  }

  header {
    position: relative;
    z-index: 1;
    padding: 1em 0;
    box-shadow: 0px 0.1em 0.5em rgba(0, 0, 0, 0.2);
  }
  .headerclass-inner {
    padding-left:2rem;
    padding-right:2rem;
  }
}
</style>
